import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
//import jwt_decode from 'jwt-decode';
import { jwtDecode } from "jwt-decode";
class ProtectedRoute extends React.Component {
  isAuthenticated() {

    const token = localStorage.getItem('access_token');
    if (token) {
      try {
        //const decodedToken = jwt_decode(token);
        const decodedToken = jwtDecode(token);
     
        const currentTime = Date.now() / 1000;
        return decodedToken.exp > currentTime;
      } catch (error) {
        return false;
      }
    }
    return false;
  }

  render() {
    const { component: Component, ...rest } = this.props;
    const isAuthenticated = this.isAuthenticated();

    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Component {...props} />
          ) : (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          )
        }
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.user.bearerToken,
  };
};

export default connect(mapStateToProps)(ProtectedRoute);
